const actions = {
  /**
   * Fetch the endpoint list.
   *
   * @param commit
   * @param $http
   * @returns {Promise<void>}
   */
  async fetchEndpointList({ commit, rootState: { $http } }) {
    const { data } = await $http.get('/endpoint/');

    commit('setEndpoints', data);
  },

  /**
   * Toggle the endpoint.
   *
   * @param $http
   * @param id
   * @returns {Promise<void>}
   */
  async toggleEndpoint({ rootState: { $http } }, { id }) {
    await $http.post(`/endpoint/${id}/toggle`);
  },

  /**
   * Fetch the endpoint.
   *
   * @param commit
   * @param $http
   * @param id
   * @returns {Promise<void>}
   */
  async fetchEndpoint({ commit, rootState: { $http } }, { id }) {
    const { data } = await $http.get(`/endpoint/${id}`);

    commit('setEndpoint', data);
  },

  /**
   * Update the endpoint.
   *
   * @param $http
   * @param id
   * @param form
   * @returns {Promise<any>}
   */
  async updateEndpoint({ rootState: { $http } }, { id, form }) {
    const { data } = await $http.put(`/endpoint/${id}`, form);

    return data;
  },

  /**
   * Store the endpoint.
   *
   * @param $http
   * @param form
   * @returns {Promise<any>}
   */
  async storeEndpoint({ rootState: { $http } }, { form }) {
    const { data } = await $http.post('/endpoint', form);

    return data;
  },
};

export default actions;
